import React, { memo, forwardRef } from "react";
const SvgCapitalChi = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M22.872 22.288c.256.368.384.68.384.936 0 .336-.12.616-.36.84-.24.224-.528.336-.864.336-.384 0-.744-.224-1.08-.672l-4.872-6.744-4.824 6.744c-.32.432-.68.648-1.08.648-.336 0-.616-.104-.84-.312a1.14 1.14 0 01-.336-.84c0-.256.128-.568.384-.936l5.232-7.104L9.984 9.04c-.24-.32-.36-.624-.36-.912 0-.304.112-.568.336-.792.24-.224.52-.336.84-.336.416 0 .776.208 1.08.624l4.296 5.928 4.2-5.928c.288-.416.64-.624 1.056-.624.32 0 .584.104.792.312.208.208.312.464.312.768 0 .288-.104.576-.312.864l-4.608 6.288 5.256 7.056z"
      />
    </svg>
  );
});
SvgCapitalChi.displayName = "SvgCapitalChi";
const MemoForwardRef = memo(SvgCapitalChi);
export default MemoForwardRef;
